import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconImage: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 0.5H4C2.06701 0.5 0.5 2.06701 0.5 4V18C0.5 19.933 2.06701 21.5 4 21.5H18C19.933 21.5 21.5 19.933 21.5 18V4C21.5 2.06701 19.933 0.5 18 0.5ZM4 2.83333H18C18.6443 2.83333 19.1667 3.35567 19.1667 4V13.7533L15.4333 10.5683C14.2404 9.58677 12.5196 9.58677 11.3267 10.5683L2.83333 17.65V4C2.83333 3.35567 3.35567 2.83333 4 2.83333Z"
        fill="#333739"
      />
      <path
        d="M7.57077 5.67923C8.25419 6.36265 8.25419 7.47068 7.57077 8.1541C6.88735 8.83752 5.77932 8.83752 5.0959 8.1541C4.41248 7.47069 4.41248 6.36265 5.0959 5.67923C5.77931 4.99581 6.88735 4.99581 7.57077 5.67923Z"
        fill="#333739"
      />
    </svg>
  </IconStyled>
);

IconImage.defaultProps = iconDefaultProps;
IconImage.displayName = 'IconImage';

export default IconImage;
